var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileResume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: "gnav-header-1i89ga9 eac13zx0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.286 2H4.57a.558.558 0 00-.57.556v18.888c0 .312.251.556.571.556H19.43c.32 0 .571-.244.571-.556V7.556L14.286 2zM7 11.75c0 .138.112.25.25.25h9.5a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25h-9.5a.25.25 0 00-.25.25v1.5zM7.25 17a.25.25 0 01-.25-.25v-1.5a.25.25 0 01.25-.25h7.5a.25.25 0 01.25.25v1.5a.25.25 0 01-.25.25h-7.5z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileResume);
export default __webpack_public_path__ + "static/media/profileResume.709ea67b66a21731372406492d3192ef.svg";
export { ForwardRef as ReactComponent };